export default [
  {
    path: "/users",
    name: "users",
    component: () => import("@/views/pages/users/Users.vue"),
    meta: {
      hasPermission: true,
      pageTitle: "کاربران",
      breadcrumb: [
        {
          text: "کاربران",
          active: true,
        },
      ],
    },
  },
  {
    path: "/users",
    component: () => import("@/views/pages/profile/Profile.vue"),

    children: [
      {
        path: ":id",
        name: "user-detail",
        component: () =>
          import("@/views/pages/profile/profile-detail/ProfileDetail.vue"),
        meta: {
          hasPermission: true,
          pageTitle: "مشخصات",
          breadcrumb: [
            {
              text: "کاربران",
            },
            {
              text: "مشخصات",
              active: true,
            },
          ],
        },
      },
      {
        path: ":id/road-map",
        name: "users-profile-road-map",
        component: () =>
          import("@/views/pages/profile/profile-road-map/ProfileRoadMap.vue"),
        meta: {
          hasPermission: true,
          pageTitle: "مسیر یادگیری",
          breadcrumb: [
            {
              text: "پروفایل",
            },
            {
              text: "مسیر یادگیری",
              active: true,
            },
          ],
        },
      },
      {
        path: ":id/exercises",
        name: "user-exercises",
        component: () =>
          import(
            "@/views/pages/profile/profile-exercises/profileExercises.vue"
          ),
        meta: {
          hasPermission: true,
          pageTitle: "تمرین ها",
          breadcrumb: [
            {
              text: "کاربران",
            },
            {
              text: "تمرین ها",
              active: true,
            },
          ],
        },
      },
      {
        path: ":id/edit",
        name: "user-edit",
        component: () =>
          import("@/views/pages/profile/profile-edit/ProfileEdit.vue"),
        meta: {
          hasPermission: true,
          pageTitle: "ویرایش مشخصات",
          breadcrumb: [
            {
              text: "کاربران",
            },
            {
              text: "ویرایش مشخصات",
              active: true,
            },
          ],
        },
      },
      {
        path: ":id/courses",
        name: "user-courses",
        component: () =>
          import("@/views/pages/profile/profile-courses/ProfileCourses.vue"),
        meta: {
          hasPermission: true,
          pageTitle: "دوره ها",
          breadcrumb: [
            {
              text: "کاربران",
            },
            {
              text: "دوره ها",
              active: true,
            },
          ],
        },
      },
      {
        path: ":id/audit-logs",
        name: "user-audit-logs",
        component: () =>
          import(
            "@/views/pages/profile/profile-audit-logs/ProfileAuditLogs.vue"
          ),
        meta: {
          hasPermission: true,
        },
      },
      {
        path: ":id/paid",
        name: "user-paid-items",
        component: () =>
          import(
            "@/views/pages/profile/profile-paid-items/ProfilePaidItems.vue"
          ),
        meta: {
          hasPermission: true,
          pageTitle: "پرداختی های کاربر",
          breadcrumb: [
            {
              text: "کاربران",
            },
            {
              text: "پرداختی های کاربر",
              active: true,
            },
          ],
        },
      },
      {
        path: ":id/devices",
        name: "user-devices",
        component: () =>
          import("@/views/pages/profile/profile-devices/ProfileDevices.vue"),
      },
      {
        path: ":id/penalties",
        name: "user-penalties",
        component: () =>
          import(
            "@/views/pages/profile/profile-penalties/ProfilePenalties.vue"
          ),
      },
      {
        path: ":id/transactions",
        name: "user-transactions",
        component: () =>
          import(
            "@/views/pages/profile/profile-transactions/ProfileTransactions.vue"
          ),
      },
    ],
  },
];
